import { jsonMember, jsonObject } from 'typedjson';
import { Guid } from '@web/utils';
import { MultimediaResponse } from '@web/shared/module/multimedia';

@jsonObject
export class PublicCosmeticBrandResponse {
  @jsonMember(String)
  public readonly id!: Guid;

  @jsonMember(String)
  public readonly name!: string;

  @jsonMember(String)
  public readonly slug!: string;

  @jsonMember(MultimediaResponse)
  public readonly logo!: MultimediaResponse;
}
